export default __webpack_public_path__ + "static/media/card_uttu2.44e7e636.png";